/**
 * 将「标题 + 竖排菜名」的 DOM 转成 PDF Blob（html2canvas 可正确渲染中文）
 */
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

/**
 * @param {HTMLElement} element 已渲染的打印区域
 * @returns {Promise<Blob>}
 */
export async function elementToPdfBlob(element) {
  const canvas = await html2canvas(element, {
    scale: 2,
    backgroundColor: '#ffffff',
    useCORS: true
  })
  const imgData = canvas.toDataURL('image/png')
  const pdf = new jsPDF('p', 'mm', 'a4')
  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const margin = 10
  const imgWidth = pageWidth - margin * 2
  const imgHeight = (canvas.height * imgWidth) / canvas.width

  let heightLeft = imgHeight
  let y = margin
  pdf.addImage(imgData, 'PNG', margin, y, imgWidth, imgHeight)
  heightLeft -= pageHeight - margin

  while (heightLeft > 0) {
    y = heightLeft - imgHeight + margin
    pdf.addPage()
    pdf.addImage(imgData, 'PNG', margin, y, imgWidth, imgHeight)
    heightLeft -= pageHeight
  }

  return pdf.output('blob')
}

/**
 * 触发浏览器下载已生成的 PDF
 */
export function downloadBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export function buildPdfFileName(orderDate, roomName) {
  const safe = `${orderDate}_${roomName}`.replace(/[\\/:*?"<>|]/g, '_')
  return `${safe}.pdf`
}
